export default function AutomationHeroIllustration() {
  return (
    <svg className="illustration" width="120" height="96" viewBox="0 0 120 96" fill="none">
      <rect x="14" y="36" width="34" height="34" rx="8" fill="var(--accent-bg)" stroke="var(--accent)" strokeWidth="1.5" />
      <circle cx="24" cy="48" r="2.5" fill="var(--accent)" />
      <circle cx="38" cy="48" r="2.5" fill="var(--accent)" />
      <path d="M22 60h18" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" />
      <path d="M48 53h14" stroke="var(--brand-red)" strokeWidth="1.6" strokeDasharray="3 3" />
      <rect x="62" y="30" width="44" height="46" rx="8" fill="var(--brand-red-bg)" stroke="var(--brand-red)" strokeWidth="1.5" />
      <path d="M76 48l6 6 12-14" stroke="var(--brand-red)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="74" y="62" width="20" height="4" rx="2" fill="var(--brand-red)" opacity="0.4" />
      <path d="M18 20l3 3M28 16v4M38 20l-3 3" stroke="var(--accent)" strokeWidth="1.6" strokeLinecap="round" opacity="0.6" />
    </svg>
  );
}
